// @flow
// $FlowFixMe
import frontendDefaultApiVersion from './apiDefault';

// $FlowFixMe
export * from './apiVersion';

const getRootUrl = () => {
  let rootUrl = '';

  if (process && process.env && process.env.WEBAPP_ROOT_URL) {
    rootUrl = process.env.WEBAPP_ROOT_URL.replace(/\/$/, ''); // strip the trailing slash if there is one
  }
  return rootUrl;
};

export const fullUrl = (path: string) => {
  const rootUrl = getRootUrl();
  return rootUrl ? `${rootUrl}${path}` : path;
};

export const systemsUrl = (suffix: string = '') => `/systems/${suffix}`;

export const fullSystemsUrl = (suffix: string) => fullUrl(systemsUrl(suffix));

export const apiUrl = (suffix: string = '', version: string = frontendDefaultApiVersion) =>
  `/api/${version}/${suffix}`;

export const fullApiUrl = (suffix: string, version?: string) => fullUrl(apiUrl(suffix, version));

export { frontendDefaultApiVersion };
export default {
  apiUrl,
  fullApiUrl,
};



// WEBPACK FOOTER //
// ../utilities/apiUrl.js